import { Box, Grid } from "@mui/material";
import NunitoText from "../general/NunitoText";
import ReusableButton from "../general/ReusableButton";
import ReusableSelect from "../general/ReusableSelect";
import { useState } from "react";
import ReusableAutocompleteWithID from "../general/ReusableAutocompleteWithID";

export default function EditFinalAwardModal({
  setcurrentFinalAward,
  currentRowFinalAward,
  isSimoc,
  updateFinalAward,
  setEditModal,
  awards,
  selectedRowKeys,
}) {
  const [award, setAward] = useState(
    currentRowFinalAward?.final_award ? currentRowFinalAward?.final_award : ""
  );

  console.log(awards);
  const options = awards
    ? awards.map((award) => ({
        id: award,
        name: award,
      }))
    : [
        {
          id: "Bronze",
          name: "Bronze",
        },
        {
          id: "Silver",
          name: "Silver",
        },
        {
          id: "Bronze",
          name: "Bronze",
        },
        {
          id: "Silver",
          name: "Silver",
        },
        {
          id: "Gold",
          name: "Gold",
        },
      ];
  console.log(currentRowFinalAward);
  const constructPayload = () => {
    if (currentRowFinalAward) {
      return [
        {
          team_number: currentRowFinalAward?.team_number,
          final_award: award,
        },
      ];
    } else {
      const payloadArr = [];
      selectedRowKeys.map((el) => {
        payloadArr.push({
          team_number: el?.team_number,
          final_award: award,
        });
      });
      return payloadArr;
    }
  };
  return (
    <Box
      className="popUpModal"
      style={{ width: 705, minHeight: 310 }}
      display={"flex"}
      alignItems={"center"}
      flexDirection={"column"}
    >
      <NunitoText
        value="Change Final Award"
        fontSize={30}
        fontWeight={600}
        color="var(--color-primary)"
        marginTop={30}
      />
      <ReusableAutocompleteWithID
        width={550}
        type={"default"}
        placeholder="Final Award"
        state={award}
        setState={setAward}
        borderColor="var(--color-border-strong)"
        options={options.map((c) => ({
          id: c.id,
          option: c.name,
        }))}
      />

      <Grid
        container
        justifyContent="space-evenly"
        style={{ marginBlock: "30px 20px" }}
      >
        <ReusableButton
          text="Cancel"
          bgColor="var(--color-surface)" color="var(--color-primary)" borderColor="var(--color-border-strong)"
          fontSize={25}
          height={63}
          width={280}
          onClick={() => {
            setEditModal(false);
            setcurrentFinalAward();
          }}
        />
        <ReusableButton
          text="Confirm"
          bgColor="var(--color-primary)"
          fontSize={25}
          height={63}
          width={280}
          onClick={() => {
            updateFinalAward(constructPayload());
          }}
        />
      </Grid>
    </Box>
  );
}
